import * as React from 'react';
import { Logo } from './Logo';
import { cn } from '../utils/cn';

export interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
  brandName?: string;
  brandHref?: string;
  nav?: React.ReactNode;
  actions?: React.ReactNode;
  variant?: 'light' | 'transparent';
}

/**
 * Felső navigáció — fehér + halvány árnyék (light) vagy átlátszó (hero felett).
 */
export function Header({
  brandName,
  brandHref = '/',
  nav,
  actions,
  variant = 'light',
  className,
  ...props
}: HeaderProps) {
  return (
    <header
      className={cn(
        'sticky top-0 z-40 w-full',
        variant === 'light'
          ? 'border-b border-[var(--color-border)] bg-white/90 backdrop-blur-md'
          : 'bg-transparent',
        className,
      )}
      {...props}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center gap-6 px-4 sm:px-6 lg:px-8">
        <a
          href={brandHref}
          className="flex items-center gap-2 transition-opacity hover:opacity-80"
          aria-label={brandName ?? 'Kezdőlap'}
        >
          <Logo brandName={brandName} />
        </a>
        {nav ? (
          <nav className="hidden flex-1 items-center gap-6 text-sm font-medium md:flex">{nav}</nav>
        ) : (
          <div className="flex-1" />
        )}
        {actions ? <div className="flex items-center gap-3">{actions}</div> : null}
      </div>
    </header>
  );
}
